import React, { useState } from "react";
// import CustomerReview from "../HomeInteriors/CustomerReviews.js";
import Form from "../HomeInteriors/Homepage/Form.js";
import "../../../public/styles/HomeInteriors/Header.scss";
import HIFooter from "../HomeInteriors/Footer.js";
import { Route, Switch } from "react-router-dom";
import HomePage from "../HomeInteriors/Homepage/index.js";
import RecentWorks from "../HomeInteriors/RecentWorks/index.js";
import { LastLocationProvider } from "react-router-last-location";
import Modal from "react-bootstrap/lib/Modal";
import HILocateUs from "./HILocateUs.js";
import HomeInteriorTags from "../Primitives/HomeInteriorTags.js";

export default function HomeInteriors() {

  const [isOpen, setIsOpen] = useState(false);
  const [doNotScrollToForm, setDoNotScrollToForm] = useState(false);

  const closeModal = () => {
    setIsOpen(false);
  }

  const openModal = () => {
    setIsOpen(true);
  }

  const doNotScroll = () =>{
    setDoNotScrollToForm(true);
  }



  return (
    <div className="home-interiors-page">
      {/* <Header 
        doNotScrollToForm={doNotScrollToForm}
        openModal={openModal}
      /> */}

      <LastLocationProvider>
        <Switch>
          <Route  path="/home-interiors/home-interiors-near-me" render={(props) => <HILocateUs />} />
         
          <Route  path="/home-interiors/our-work" render={(props) => <RecentWorks doNotScroll={doNotScroll} openModal={openModal} {...props} />} />
          <Route path="/home-interiors" component={HomePage}/>
        </Switch>
      </LastLocationProvider>
      <HomeInteriorTags />
      <HIFooter />

      <Modal
        show={isOpen}
        fullscreen="true"
        centered
        dialogClassName="home-interiors-page custom"
      >
        <div className="close-btn-div">
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={closeModal}
          >
            <span aria-hidden="true">&#10005;</span>
          </button>
        </div>
        <Modal.Body>
          <Form />
        </Modal.Body>
      </Modal>
    </div>
  );
}
